<template>
  <v-app id="app_measurements">
    <v-overlay
      v-model="centerLoading"
      class="custom_centered_overlay"
    >
      <v-progress-circular
        color="#2A8200"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <v-container fluid>
      <v-row>
        <v-col class="mt-0" cols="7">
          <p class="custom_page_main_title">OFFICERS DAY IN REQUEST</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">
            Used to manage day in requests.
          </p>
        </v-col>
        <v-col class="px-4 mt-7" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider
              :thickness="3"
              class="divider-vertical"
              vertical
            ></v-divider>
            <v-btn
              class="gray-text"
              size="x-large"
              variant="text"
              @click="backPageRoute"
            >
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="pa-5 mt-5">
        <v-row justify="end">
          <v-col cols="auto">
            <v-btn
              class="custom_excel_btn"
              variant="outlined"
              @click="exportExcelDayInRequestList"
            >
              <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
            </v-btn>
          </v-col>
          <v-divider></v-divider>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedOfficerTitle"
              :items="officerTitleList"
              clearable
              item-title="role_type"
              item-value="id"
              label="Officer Category"
              multiple
              placeholder="Select Officer Category"
              variant="outlined"
              density="comfortable"
              @update:modelValue="applyFilters"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedOfficer"
              :items="officersListBasedOnRole"
              clearable
              item-title="name"
              item-value="id"
              label="Officer"
              multiple
              placeholder="Select Officer Name"
              variant="outlined"
              density="comfortable"
              @update:modelValue="applyFilters"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-date-input
              v-model="dates"
              label="Select Date Range"
              prepend-icon=""
              prepend-inner-icon="$calendar"
              multiple="range"
              variant="outlined"
              clearable
              @update:model-value="onDateRangeSelected"
              @click:clear="clearDateRange"
              density="comfortable"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedPremiseCode"
              :items="premiseCodeList"
              clearable
              item-title="role_type"
              item-value="id"
              label="Premise Code"
              placeholder="Select Premise Code"
              variant="outlined"
              density="comfortable"
              @update:modelValue="applyFilters"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedDivisionCode"
              :items="divisionCodeList"
              clearable
              item-title="name"
              item-value="id"
              label="Division Code"
              placeholder="Select Division Code"
              variant="outlined"
              density="comfortable"
              @update:modelValue="applyFilters"
            />
          </v-col>

          <v-col cols="12" md="4">
              <v-text-field
                  v-model="search" append-inner-icon="mdi-magnify" clearable hide-details label="Search"
                  placeholder="Search" variant="outlined" density="comfortable" class="custom_input_field_color"
              ></v-text-field>
            </v-col>
        </v-row>

        <v-row
          class="pa-2 mb-4"
          style="
            background-color: #fff3cd;
            border: 1px solid #566573;
            border-radius: 4px;
          "
        >
          <v-col class="d-flex align-center" cols="12">
            <v-icon color="success" size="small" class="mr-1"
              >mdi-checkbox-blank-circle</v-icon
            >
            <span class="mr-4" style="font-size: 12px; color: #333"
              >ON TIME</span
            >

            <v-icon color="error" size="small" class="mr-1"
              >mdi-checkbox-blank-circle</v-icon
            >
            <span style="font-size: 12px; color: #333">LATE</span>
          </v-col>
        </v-row>

        <v-data-table
          class="mt-4"
          :group-by="groupBy"
          :headers="headers"
          :items="filteredDayInData"
          :loading="loading"
          item-value="user_id"
          show-group-by
        >
          <template
            v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }"
          >
            <tr>
              <td :colspan="columns.length">
                <v-btn
                  :icon="isGroupOpen(item) ? '$expand' : '$next'"
                  size="small"
                  variant="text"
                  @click="toggleGroup(item)"
                />
                  <span class="text-muted">
                    {{item.value.split(' - ')[0]}}
                  </span>
                  <br />
                  <span class="blue--text font-weight-bold pl-10">
                    Employee ID: {{item.value.split(' - ')[1] }}
                  </span>
              </td>
            </tr>
          </template>

          <template v-slot:[`item.dayIn`]="{ item }">
            <div class="d-flex align-center">
              <v-icon
                v-if="item.status =='On-Time'"
                color="success"
                size="small"
                class="mr-1"
              >
                mdi-checkbox-blank-circle
              </v-icon>
              <v-icon
                v-else
                color="error"
                size="small"
                class="mr-1"
              >
                mdi-checkbox-blank-circle
              </v-icon>
              <div>
                <span>{{ item.day_in_time || "N/A" }}</span> <br />
                <span class="blue--text font-weight-bold">{{
                  item.day_in_location || "N/A"
                }}</span>
              </div>
            </div>
          </template>

          <template v-slot:[`item.date`]="{ item }">
            {{ new Date(item.day_in_date).toISOString().slice(0, 10).replace(/-/g, '/')}}
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <v-btn
              style="
                width: 90% !important;
                background-color: #e6effc !important;
                border: 1px solid #0000ff !important;
                color: #0000ff !important;
              "
              variant="outlined"
              @click="openActionDialog(item)"
              :disabled="!permissions.write"
            >
              ACTION
            </v-btn>
          </template>
        </v-data-table>

        <v-dialog
          v-model="InRequestdialog"
          max-height="700"
          id="app_lead_list"
          max-width="600"
        >
          <v-card rounded="md">
            <div class="pa-4">
              <v-card color="#F0F0F0" flat>
                <template v-slot:prepend>
                  <v-card-title class="text-subtitle-1 font-weight-bold">
                    APPROVE DAY IN REQUEST
                  </v-card-title>
                </template>
                <v-spacer></v-spacer>
                <template v-slot:append>
                  <v-btn
                    @click="InRequestdialog = false"
                    icon="mdi-close"
                    size="x-small"
                  ></v-btn>
                </template>
              </v-card>

              <!-- Form Content -->
              <v-card-text>
                <v-form ref="form">
                  <v-text-field
                    v-model="selectedItem.user.name"
                    label="Officer name"
                    placeholder="Officer name"
                    variant="outlined"
                    required
                    readonly
                  ></v-text-field>

                  <v-text-field
                    v-model="selectedItem.day_in_date"
                    label="Date"
                    placeholder="Date"
                    variant="outlined"
                    required
                    readonly
                  ></v-text-field>

                  <v-textarea
                    v-model="selectedItem.remark"
                    label="Message"
                    placeholder="Enter your message"
                    readonly
                  ></v-textarea>
                </v-form>
              </v-card-text>

              <!-- Action Buttons -->
              <v-card-actions class="d-flex justify-end">
                <v-btn
                  style="
                    width: 30% !important;
                    background-color: #e6effc !important;
                    border: 1px solid #0000ff !important;
                    color: #0000ff !important;
                  "
                  variant="outlined"
                  @click="approveRequest"
                >
                  APPROVE
                </v-btn>
                <v-btn
                  style="
                    width: 30% !important;
                    background-color: #fdecea !important;
                    border: 1px solid #f44336 !important;
                    color: #f44336 !important;
                  "
                  variant="outlined"
                  @click="rejectApproveddialog = true"
                >
                  REJECT
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>
        </v-dialog>
      </v-card>

      <v-dialog
        v-model="rejectApproveddialog"
        max-height="700"
        id="app_lead_list"
        max-width="600"
      >
        <v-card rounded="md">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">
                  REJECT REQUEST
                </v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn
                  @click="rejectApproveddialog = false"
                  icon="mdi-close"
                  size="x-small"
                ></v-btn>
              </template>
            </v-card>

            <!-- Form Content -->
            <v-card-text>
              <v-form ref="form">
                <v-textarea autocomplete="Message" label="Message" v-model="rejectReason" :counter="maxChars"
                            :maxlength="maxChars"></v-textarea>
              </v-form>
            </v-card-text>

            <!-- Action Buttons -->
            <v-card-actions class="d-flex justify-end">
              <v-btn
                style="
                  width: 30% !important;
                  background-color: #fdecea !important;
                  border: 1px solid #f44336 !important;
                  color: #f44336 !important;
                "
                variant="outlined"
                @click="rejectRequest"
              >
                REJECT
              </v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar" :color="snackbarColor" location="top-right" outlined timeout="3000">
          {{snackbarMessage}}
          <template v-slot:action="{ attrs }">
            <v-btn icon v-bind="attrs" @click="snackbar = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import * as XLSX from 'xlsx';
import { getPermissions } from "@/plugins/permissions";

export default {
  data() {
    return {
      centerLoading: false,
      rejectApproveddialog:false,
      loading: false,
      search:'',
      selectedRoles: [],
      selectedOfficers: [],
      dateRange: [],
      message: "",
      snackbar: false,
      snackbarColor:"",
      snackbarMessage:"",
      rejectReason:"",
      permissions: {},
      selectedItem: {
        user: {
          name: "",
        },
        day_in_date: "",
      },
       maxChars: 200,
      InRequestdialog: false,
      roleItems: [],
      officerItems: [],
      groupBy: [{ key: "group_by_user", order: "asc" }],
      headers: [
        // {
        //   title: "OFFICER NAME",
        //   align: "start",
        //   sortable: false,
        //   key: "user.name",
        // },
        { title: "DAY IN", key: "dayIn" },
        { title: "DATE", key: "date" },
        { title: "ACTION", key: "action" },
      ],
      originalData: [],
      filteredData: [],
      officerTitleList:[],
      officersListBasedOnRole:[],
      selectedOfficerTitle:null,
      selectedOfficer:null,
      divisionCodeList:[],
      selectedDivisionCode:null,
      premiseCodeList:[],
      selectedPremiseCode:null,

      startDate:null,
      endDate:null,

      dates:null,
    };
  },
  created() {
    this.getOfficerTitles();
    this.fetchData();
  },
  mounted() {

    const dashboardId = 10;
    this.permissions = getPermissions(dashboardId);
  },
  computed: {
    filteredDayInData() {
      if (!this.search) return this.filteredData;

      const keyword = this.search.toLowerCase();

      return this.filteredData.filter(item => {
        return (
          item?.group_by_user?.toLowerCase().includes(keyword) ||
          item?.user_id?.toString().includes(keyword) ||
          item?.day_in_time?.toLowerCase().includes(keyword) ||
          item?.day_in_location?.toLowerCase().includes(keyword) ||
          item?.day_in_date?.toLowerCase?.().includes(keyword) ||
          item?.status?.toLowerCase().includes(keyword)
        );
      });
    }
  },
  watch: {
    selectedOfficerTitle(newVal) {
      this.selectedOfficer = "";
      this.getUserListBasedOnRoles(newVal); // This triggers on every checkbox change
    },

    selectedOfficer(newVal){
      this.selectedOfficer = newVal;
      this.fetchData();
    },

    selectedPremiseCode(newVal){
      this.selectedPremiseCode = newVal;
      this.fetchData();
    },
    selectedDivisionCode(newVal){
      this.selectedDivisionCode = newVal;
      this.fetchData();
    }
  },
  methods: {
    async fetchData() {
      this.centerLoading = true;
      this.loading = true;
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}api/am/web/day-in-request/get`, {startDate:this.startDate, endDate:this.endDate, selectedOfficers: this.selectedOfficer, selectedPremiseCode: this.selectedPremiseCode, selectedDivisionCode: this.selectedDivisionCode}
        );

        if (response.data.success) {
          this.originalData = response.data.data.map((item) => ({
            ...item,
            officerName: item.user
              ? item.user.name
              : `Unknown User (ID: ${item.user_id})`,
            role: item.user ? item.user.role : "Unknown",
          }));

          this.filteredData = [...this.originalData];

          // Extract unique roles
          this.roleItems = this.extractUniqueItems("role");

          // Extract all officers
          this.officerItems = this.extractOfficerItems();
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.centerLoading = false;
        this.loading = false;
      }
    },

    getOfficerTitles() {
            this.centerLoading = true;
            // const userId = localStorage.getItem('userId');
            const token = localStorage.getItem('token');

            axios.post(`${process.env.VUE_APP_API_BASE_URL}api/um/web/get-mobile-user-roles`, {}, {
                headers: {
                Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
                }
            })
                .then(response => {
                    this.officerTitleList = response.data.data;
                    this.divisionCodeList = response.data.divisionCode;
                    this.premiseCodeList = response.data.premiseCode;
                    
                    this.centerLoading = false;
                    
                })
                .catch(error => {
                    this.centerLoading = false;
                    console.error('Error fetching dashboard permissions:', error);
                });
            },

            getUserListBasedOnRoles(selectedRoles){
                this.centerLoading = true;
            // const userId = localStorage.getItem('userId');
            const token = localStorage.getItem('token');

            axios.post(`${process.env.VUE_APP_API_BASE_URL}api/um/web/get-mobile-users-based-on-roles`, {userRoleId:selectedRoles}, {
                headers: {
                Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
                }
            })
                .then(response => {
                    this.officersListBasedOnRole = response.data.data;
                    
                    this.centerLoading = false;
                    
                })
                .catch(error => {
                    this.centerLoading = false;
                    console.error('Error fetching ', error);
                });
            },

    extractUniqueItems(property) {
      return [
        ...new Set(
          this.originalData
            .filter((item) => item[property])
            .map((item) => item[property])
        ),
      ].map((role) => ({ role }));
    },

    extractOfficerItems() {
      return this.originalData
        .filter((item) => item.user)
        .map((item) => ({
          id: item.user_id,
          name: item.user.name,
          role: item.user.role,
        }))
        .filter(
          (officer, index, self) =>
            index === self.findIndex((o) => o.id === officer.id)
        );
    },

    applyFilters() {
      let filtered = [...this.originalData];

      // Apply role filter
      if (this.selectedRoles.length > 0) {
        filtered = filtered.filter((item) =>
          this.selectedRoles.includes(item.role)
        );
      }

      // Apply officer filter
      if (this.selectedOfficers.length > 0) {
        filtered = filtered.filter((item) =>
          this.selectedOfficers.includes(item.user_id)
        );
      }

      // Apply date range filter
      if (this.dateRange.length === 2) {
        const startDate = new Date(this.dateRange[0]);
        const endDate = new Date(this.dateRange[1]);

        filtered = filtered.filter((item) => {
          if (!item.day_in_date) return false;
          const itemDate = new Date(item.day_in_date);
          return itemDate >= startDate && itemDate <= endDate;
        });
      }

      this.filteredData = filtered;
    },

    formatDate(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return date.toLocaleDateString();
    },

    isOnTime(timeString) {
      if (!timeString) return false;

      const [hours, minutes] = timeString.split(":").map(Number);
      const totalMinutes = hours * 60 + minutes;
      const onTimeLimit = 8 * 60 + 30; // 8:30 AM

      return totalMinutes <= onTimeLimit;
    },

    openActionDialog(item) {
      this.selectedItem = JSON.parse(JSON.stringify(item));
      if (!this.selectedItem.user) {
        this.selectedItem.user = { name: `Unknown User (ID: ${item.user_id})` };
      }
      this.InRequestdialog = true;
    },

    async approveRequest() {
      try {
        this.centerLoading = true;
            const userId = localStorage.getItem('userId');
            const token = localStorage.getItem('token');

            axios.post(`${process.env.VUE_APP_API_BASE_URL}api/am/web/approve-day-in-request`, {user_id: userId, attendanceID:this.selectedItem.id}, {
                headers: {
                Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
                }
            })
                .then(response => {
                    this.overtimeRequestOfficesList = response.data.data;
                    this.snackbar = true;
                    this.snackbarColor = "success";
                    this.snackbarMessage = "Day in request was approved successfully.";
                    this.InRequestdialog = false;
                    this.centerLoading = false;
                    this.fetchData();
                })
                .catch(error => {
                    this.centerLoading = false;
                    this.snackbar = true;
                    this.snackbarColor = "error";
                    this.snackbarMessage = "Day in request approval has been failed.";
                    console.error('Error fetching', error);
                });
        
      } catch (error) {
        this.centerLoading = false;
        console.error("Error approving request:", error);
        this.snackbar = true;
        this.snackbarColor = "error";
        this.snackbarMessage = "Day in request approval has been failed.";
      }
    },

    async rejectRequest() {
      try {
        this.centerLoading = true;
            const userId = localStorage.getItem('userId');
            const token = localStorage.getItem('token');

            axios.post(`${process.env.VUE_APP_API_BASE_URL}api/am/web/reject-day-in-request`, {user_id: userId, attendanceID:this.selectedItem.id, rejectReason: this.rejectReason}, {
                headers: {
                Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
                }
            })
            // eslint-disable-next-line
                .then(response => {
                    this.snackbar = true;
                    this.snackbarColor = "success";
                    this.snackbarMessage = "Day in request was rejected successfully.";
                    this.InRequestdialog = false;
                    this.rejectApproveddialog = false;
                    this.centerLoading = false;
                    this.fetchData();
                })
                .catch(error => {
                    this.centerLoading = false;
                    this.snackbar = true;
                    this.snackbarColor = "error";
                    this.snackbarMessage = "Day in request rejection has been failed.";
                    console.error('Error fetching', error);
                });
        
      } catch (error) {
        this.centerLoading = false;
        console.error("Error approving request:", error);
        this.snackbar = true;
        this.snackbarColor = "error";
        this.snackbarMessage = "Day in request rejection has been failed.";
      }
    },

    exportExcelDayInRequestList() {
      let tableData = [];
        if(this.filteredDayInData.length > 0){
                tableData = this.filteredDayInData.map((item, index) => ({
                '#': index + 1,
                'Officer Name': item.user.name,
                'EMPLOYEE ID': item.user.registration_num,
                'Day In Date': item.day_in_date,
                'Day In Time': item.day_in_time,
                'Day In Location': item.day_in_location,
                'Status': item.status,
                'Message': item.remark,
                }));
        }else{
          tableData = [{
            '#': "",
            'Officer Name': "",
            'EMPLOYEE ID': "",
            'Day In Date': "",
            'Day In Time': "",
            'Day In Location': "",
            'Status': "",
            'Message': "",
          }];
        }

                const worksheet = XLSX.utils.json_to_sheet(tableData);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Day In Request List');
                XLSX.writeFile(workbook, 'Day_in_request_List.xlsx');

                const fileName = 'Day_in_request_List.xlsx';
                const file_type = 'excel';
                this.logDocumentDownload(fileName,file_type, "Day In Requests Officers List");
            },

        onDateRangeSelected(newDates){
                if(newDates){
                this.dates = newDates;
                
                this.startDate = new Date(this.dates[0]);
                this.startDate.setDate(this.startDate.getDate() + 1);
                this.startDate = this.startDate.toISOString().split('T')[0];
                this.endDate = this.dates.length > 1 ? new Date(this.dates[this.dates.length - 1]).toISOString().split('T')[0] : this.startDate;

                this.fetchData();

               
                }else{
                    this.dates = null;
                    this.startDate = null;
                    this.endDate =  null;
                    this.fetchData();
                }
            },

            async logDocumentDownload(fileName,file_type, entityArea) {
                    
                    try {
                    const token = localStorage.getItem('token');
                    const userId = localStorage.getItem('userId');

                    if (!userId) {
                        throw new Error('User ID not found');
                    }

                    // Asynchronous API call to log download
                    const response = await axios.post(`/api/log-document-download`, {
                        user_id: userId,
                        file_type: file_type,
                        file_name: fileName,
                        entity_area: entityArea,

                        headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                        }
                    });

                    if (response.status !== 200) {
                        throw new Error('Failed to log download');
                    }

                    
                    } catch (error) {
                    console.error('Error logging download:', error);
                    }
                },

    clearDateRange() {
      this.dateRange = [];
      this.applyFilters();
    },

    backPageRoute() {
      this.$router.go(-1);
    },

    exportExcel() {
      console.log("Export Excel clicked");
      this.$toast.info(
        "Export to Excel functionality would be implemented here"
      );
    },
  },
};
</script>

<style scoped>
.blue--text {
  color: blue;
}

.custom_centered_overlay {
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom_page_main_title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.custom_page_main_sub_title {
  font-size: 14px;
  color: #666;
}

.custom_tool_bar_style {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.divider-vertical {
  height: 40px;
  margin: 0 16px;
}

.custom_input_field_color {
  background-color: #f5f5f5;
}
</style>